import request from '@/utils/request'
/**
 * 提交反馈
 */
  export function submit(data) {
    return request({
      url: 'user/useridea/',
      method: 'post',
      data
    })
  }